// User
export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";

// Mutations
export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const BUSINESS_SUCCESS = "BUSINESS_SUCCESS";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const DELETE_PROFILE = "DELETE_PROFILE";
